<template>
  <div class="focusBanner_w">
    <el-carousel trigger="click" :interval="5000" height="316px">
      <el-carousel-item v-for="item in focusesData" :key="item.id">
        <div class="cursor_pointer" @click="onBannerClick(item)">
          <img :src="item.cover+'!529'" alt="轮播图" style="width:100%;height:316px">
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { recursiveFind } from '@/utils'
import Cookies from 'js-cookie'

export default {
  data() {
    return {
      articleNode:null,
    }
  },
  computed: {
    ...mapGetters(['siteInfo', 'focusesData', 'nodeMap'])
  },
  watch:{
    siteInfo:{
      handler(n){
        if(Object.keys(n).length){
          this.initFocusesData()
        }
      },
      immediate:true,
      deep:true,
    }
  },
  created() {

  },
  methods: {
    ...mapActions({
      'initFocusesData': 'cache/initFocusesData'
    }),
    // 轮播图点击 click
    onBannerClick(item) {
      Cookies.set('cmsNodeChlidId', this.nodeMap[item.kind])

      this.articleNode = recursiveFind(this.siteInfo.nodes, 'code', item.kind)

      this.$router.push(`${this.articleNode.infoModel.route}/${item.id}`)
    }

  }
}
</script>

<style lang="scss" scoped>
.focusBanner_w{
  width: 529px;
  height: 316px;
}
</style>
